module.exports = __webpack_public_path__ + "img/header-engagementRingsCharisma\n@2x.7178778.webp";